import { dependencies } from '../../../../configurations/dependencies/dependencies';

const APP_GATE_STORAGE_KEY = 'app_gate_authorized';

export class AppGateService {
  static isAuthorized(): boolean {
    return localStorage.getItem(APP_GATE_STORAGE_KEY) === 'true';
  }

  static async verifyAppPassword(password: string): Promise<boolean> {
    try {
      const isAuthorized =
        await dependencies.tempGateGateway.verifyAppPassword(password);

      if (isAuthorized) {
        localStorage.setItem(APP_GATE_STORAGE_KEY, 'true');
      }

      return isAuthorized;
    } catch (error) {
      console.error('Error in AppGateService:', error);
      return false;
    }
  }

  static clearAuthorization(): void {
    localStorage.removeItem(APP_GATE_STORAGE_KEY);
  }
}
